export default "__VITE_ASSET__BOUUJ4Vc__"